function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.5,0h0C5.6,0,0,5.6,0,12.5h0c0,6.9,5.6,12.5,12.5,12.5h0c6.9,0,12.5-5.6,12.5-12.5h0C25,5.6,19.4,0,12.5,0Zm6.56,15.89c0,1.75-1.42,3.17-3.17,3.17h-6.78c-1.75,0-3.17-1.42-3.17-3.17v-6.78c0-1.75,1.42-3.17,3.17-3.17h6.78c1.75,0,3.17,1.42,3.17,3.17v6.78Z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 12.51,
  cy: 12.5,
  r: 2.26
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m15.67,7.07h-6.33c-1.25,0-2.26,1.01-2.26,2.26v6.33c0,1.25,1.01,2.26,2.26,2.26h6.33c1.25,0,2.26-1.01,2.26-2.26v-6.33c0-1.25-1.01-2.26-2.26-2.26Zm-3.16,8.82c-1.87,0-3.39-1.52-3.39-3.39s1.52-3.39,3.39-3.39,3.39,1.52,3.39,3.39-1.52,3.39-3.39,3.39Zm3.62-6.33c-.37,0-.68-.3-.68-.68s.3-.68.68-.68.68.3.68.68-.3.68-.68.68Z"
}));

var SvgEroskiFooter3Instagram = function SvgEroskiFooter3Instagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    id: "instagram",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter3Instagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer3-instagram.7478a4e4.svg";
export { ForwardRef as ReactComponent };